import React from 'react';
import './Terms.css';

const PrivacyPolicyIT = () => {
  return (
    <div className="terms-page">
      <h1>Informativa sulla Privacy</h1>
      <div className="terms-main">
        <p>
          <strong>Rewards & Samples, LLC</strong> ("noi", "nostro" o "ci") fornisce la seguente 
          Informativa sulla Privacy ("Informativa sulla Privacy" o "Politica"), che stabilisce 
          le nostre pratiche relative alla raccolta, all'uso, alla divulgazione e alla vendita 
          di informazioni personalmente identificabili di un utente ("Informazioni").
        </p>

        <h3>1. ACCETTAZIONE DELL'INFORMATIVA SULLA PRIVACY</h3>
        <p>
          Accedendo e utilizzando il nostro sito web, che possediamo e gestiamo e che offre 
          premi e/o altri contenuti agli utenti (collettivamente, il "Sito Web"), accetti 
          questa Informativa sulla Privacy e acconsenti alla raccolta, all'uso, alla 
          divulgazione e alla vendita delle tue Informazioni come qui descritto.
        </p>

        <h3>2. TIPI DI INFORMAZIONI CHE RACCOGLIAMO</h3>
        <p>
          Potremmo raccogliere i seguenti tipi di informazioni sugli utenti:
        </p>
        <ul>
          <li>Informazioni identificabili come nome, indirizzo postale, indirizzo(i) email, 
          numero(i) di telefono cellulare, data di nascita e sesso</li>
          <li>Informazioni raccolte dalle risposte di un utente alle domande del sondaggio, 
          incluse preferenze e attributi personali</li>
          <li>Informazioni raccolte dai file di registro del nostro server web, inclusi 
          tipo(i) di dispositivo, dati dell'agente utente, URL di riferimento e indirizzo(i) IP</li>
          <li>Informazioni relative all'interazione di un utente con chiamate di telemarketing, 
          messaggi SMS, notifiche push, email commerciali e altre forme di comunicazione</li>
        </ul>

        <h3>3. USO DEI COOKIE</h3>
        <p>
          Il nostro sito web utilizza i cookie per determinare se gli utenti hanno visitato 
          precedentemente il sito web e per semplificare il processo di registrazione. Potremmo 
          anche utilizzare i cookie per migliorare l'esperienza di un utente sul sito web.
        </p>

        <h3>4. DIRITTI GDPR</h3>
        <p>
          Ai sensi del Regolamento Generale sulla Protezione dei Dati (GDPR), hai i seguenti diritti:
        </p>
        <ul>
          <li><strong>Diritto di accesso:</strong> Hai il diritto di ottenere informazioni 
          sui tuoi dati personali</li>
          <li><strong>Diritto di rettifica:</strong> Hai il diritto di far correggere dati 
          personali inesatti</li>
          <li><strong>Diritto alla cancellazione:</strong> Hai il diritto di richiedere la 
          cancellazione dei tuoi dati personali</li>
          <li><strong>Diritto alla limitazione del trattamento:</strong> Hai il diritto di 
          richiedere la limitazione del trattamento</li>
          <li><strong>Diritto alla portabilità dei dati:</strong> Hai il diritto di ricevere 
          i tuoi dati in un formato strutturato</li>
          <li><strong>Diritto di opposizione:</strong> Hai il diritto di opporti al 
          trattamento dei tuoi dati personali</li>
        </ul>

        <h3>5. TRASFERIMENTO DEI DATI</h3>
        <p>
          Le tue informazioni possono essere trasferite e conservate su server al di fuori 
          dello Spazio Economico Europeo (SEE). Utilizzando i nostri servizi, acconsenti a 
          questo trasferimento.
        </p>

        <h3>6. SICUREZZA DEI DATI</h3>
        <p>
          Utilizziamo sforzi commercialmente ragionevoli per prevenire l'accesso non 
          autorizzato, la divulgazione o la perdita o distruzione accidentale delle tue 
          informazioni. L'accesso alle tue informazioni è strettamente limitato.
        </p>

        <h3>7. MODIFICHE A QUESTA POLITICA</h3>
        <p>
          Ci riserviamo il diritto di rivedere e aggiornare questa politica in qualsiasi 
          momento. Le modifiche sostanziali saranno pubblicate sul sito web e entreranno 
          in vigore trenta (30) giorni dopo la pubblicazione.
        </p>

        <h3>8. CONTATTO</h3>
        <p>
          Se hai domande, commenti o suggerimenti su questa politica o sul sito web, 
          ti preghiamo di contattarci.
        </p>

        <div className="last-updated">
          Ultimo aggiornamento: Gennaio 2026
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyIT;
